import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { LOCALE_ID, Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SimpleLocaleService } from "@core/services/simple-locale.service";

@Injectable({
  providedIn: 'root'
})
export class LocalizationInterceptor implements HttpInterceptor {

  // Constructor
  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private simpleLocaleService: SimpleLocaleService
  ) {
    // Inject and set the current locale
    this.locale = locale;
  }

  // Intercept HTTP requests
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if(request.url.startsWith("/signalR")){
      return next.handle(request);
    }

    // Get the current locale from the simple service
    const currentLocale = this.simpleLocaleService.getCurrentLocale();

    console.log('Intercepting request to set Accept-Language header:', currentLocale);

    // Set any outgoing HTTP requests to accept the langugage of the current operating locale.
    let newHeaders = request.headers.delete('Accept-Language');
    newHeaders = newHeaders.set('Accept-Language', currentLocale);

    const newRequest = request.clone({  headers: newHeaders });

    return next.handle(newRequest);
  }

}
